import { ShiftTable } from '../../../src_server/entity/generated/ShiftTable';


import { ShiftTableDTO } from '../../../src_server/entity/dto/ShiftTableDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';


import { Schedule } from '../../../src_server/param/Schedule';export class ShiftTableService extends GeneratedBizBase{
  async insertSchedule(user_id: string,schedules: Schedule[]): Promise<Response<ShiftTable[]>> {
    return super.restCall<Response<ShiftTable[]>>('post', '/v1/ShiftTableService/insertSchedule', arguments);
  }
  async getScherduleByTeacherUserId(user_id: string): Promise<Response<ShiftTable[]>> {
    return super.restCall<Response<ShiftTable[]>>('get', '/v1/ShiftTableService/getScherduleByTeacherUserId', arguments);
  }
  async getGroupSchedule(shift_table_id: number): Promise<Response<ShiftTable[]>> {
    return super.restCall<Response<ShiftTable[]>>('get', '/v1/ShiftTableService/getGroupSchedule', arguments);
  }
  async deleteSchedule(shift_table_id: number,cascade_group: boolean): Promise<Response<number[]>> {
    return super.restCall<Response<number[]>>('post', '/v1/ShiftTableService/deleteSchedule', arguments);
  }
  async insert(schedules: ShiftTable[]): Promise<Response<ShiftTable[]>> {
    return super.restCall<Response<ShiftTable[]>>('post', '/v1/ShiftTableService/insert', arguments);
  }
  async selectBetween(user_id: string,start_dt: string,end_dt: string): Promise<Response<ShiftTableDTO[]>> {
    return super.restCall<Response<ShiftTableDTO[]>>('post', '/v1/ShiftTableService/selectBetween', arguments);
  }
  async selectBetweenAtBuilding(building_id: string,start_dt: string,end_dt: string): Promise<Response<ShiftTableDTO[]>> {
    return super.restCall<Response<ShiftTableDTO[]>>('post', '/v1/ShiftTableService/selectBetweenAtBuilding', arguments);
  }
  async getScheduleById(schedule_table_id: number): Promise<Response<ShiftTableDTO>> {
    return super.restCall<Response<ShiftTableDTO>>('post', '/v1/ShiftTableService/getScheduleById', arguments);
  }
  async updateSchedule(value: ShiftTable): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/ShiftTableService/updateSchedule', arguments);
  }
}
